import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
const Page = lazy(() => import('@/features/ban-hang/cho-thanh-toan/page-client'))
export const Route = createFileRoute('/_authed/agent/ban-hang/cho-thanh-toan')({
  component: () => <Suspense fallback={null}><Page /></Suspense>,
})